import { Router } from '@angular/router';
import { MatDialogRef, MatPaginator, MatSort } from '@angular/material';
import { ObservableMedia } from '@angular/flex-layout';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { DataTableSource } from '../../../classes/DataTableSource/datatablesource';
import { FormStatusPipe } from '../../../pipes/formstatus.pipe';
var NotificationDialogComponent = /** @class */ (function () {
    function NotificationDialogComponent(dialogRef, data, mediaChange, formStatusPipe, router) {
        this.dialogRef = dialogRef;
        this.mediaChange = mediaChange;
        this.formStatusPipe = formStatusPipe;
        this.router = router;
        this._subrelease = new Subject();
        this.TitleText = data.TitleText || 'Notification Details...';
        this.MessageText = data.MessageText || '';
        this.Notifications = data.Notifications || [];
        this.IsAdoptions = data.IsAdoptions != null ? data.IsAdoptions : false;
        this.IsAdvisor = data.IsAdvisor || false;
    }
    NotificationDialogComponent.prototype.ngOnDestroy = function () {
        this._subrelease.next();
        this._subrelease.complete();
    };
    NotificationDialogComponent.prototype.ngOnInit = function () {
        var self = this;
        self.CurrentDetails = null;
        self.LastSizeCode = self.mediaChange.isActive('xs')
            ? 'xs'
            : self.mediaChange.isActive('sm')
                ? 'sm'
                : self.mediaChange.isActive('md')
                    ? 'md'
                    : self.mediaChange.isActive('lg')
                        ? 'lg'
                        : 'xl';
        self.SmallDisplay = self.LastSizeCode === 'xs' || self.LastSizeCode === 'sm';
        self.VisibleHeaders = self.SmallDisplay
            ? ['SmallDisplay']
            : self.IsAdoptions
                ? ['RequestNumber', 'RequestorName', 'Code', 'Name', 'DateRequested', 'Actions']
                : self.IsAdvisor
                    ? ['StudentName', 'StudentID', 'College', 'CollegeTerm', 'SchoolName', 'FormStatus', 'DateUpdated', 'Actions']
                    : ['StudentName', 'StudentID', 'College', 'CollegeTerm', 'DateUpdated', 'Actions'];
        self.VisibleColumns = self.VisibleHeaders.slice();
        self.mediaChange
            .asObservable()
            .pipe(takeUntil(self._subrelease))
            .subscribe(function (media) {
            self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
            self.LastSizeCode = media.mqAlias;
            self.VisibleHeaders = self.SmallDisplay
                ? ['SmallDisplay']
                : self.IsAdoptions
                    ? ['RequestNumber', 'RequestorName', 'Code', 'Name', 'DateRequested', 'Actions']
                    : self.IsAdvisor
                        ? ['StudentName', 'StudentID', 'College', 'CollegeTerm', 'SchoolName', 'FormStatus', 'DateUpdated', 'Actions']
                        : ['StudentName', 'StudentID', 'College', 'CollegeTerm', 'DateUpdated', 'Actions'];
            self.VisibleColumns = self.VisibleHeaders.slice();
        });
        self.DetailsData = new DataTableSource([], self.paginator, self.sorter, self.SortNotifications.bind(this));
        this.ShowingFullDetail = false;
    };
    // #region OK Handler
    NotificationDialogComponent.prototype.OKHandler = function () {
        this.dialogRef.close(null);
    };
    // #endregion
    // #region Go Back Method
    NotificationDialogComponent.prototype.GoBack = function () {
        this.ShowingFullDetail = false;
    };
    // #endregion
    // #region Show Notification Details Method
    NotificationDialogComponent.prototype.ShowNotificationDetails = function (detail) {
        // Load the current details into the details database
        this.DetailsData.Update(detail.Details);
        this.ShowingFullDetail = true;
    };
    // #endregion
    // #region Sort Notifications Method
    NotificationDialogComponent.prototype.SortNotifications = function (First, Second) {
        var self = this;
        var PropA;
        var PropB;
        switch (self.sorter.active) {
            case 'StudentName':
                _a = [First.StudentName, Second.StudentName], PropA = _a[0], PropB = _a[1];
                break;
            case 'StudentID':
                _b = [First.StudentID, Second.StudentID], PropA = _b[0], PropB = _b[1];
                break;
            case 'SchoolName':
                _c = [First.SchoolName || "", Second.SchoolName || ""], PropA = _c[0], PropB = _c[1];
                break;
            case 'FormStatus':
                _d = [First.FormStatus, Second.FormStatus], PropA = _d[0], PropB = _d[1];
                break;
        }
        var ValueA = PropA != null && PropA !== '' ? (isNaN(+PropA) ? PropA : +PropA) : PropA;
        var ValueB = PropB != null && PropB !== '' ? (isNaN(+PropB) ? PropB : +PropB) : PropB;
        return (ValueA < ValueB ? -1 : 1) * (self.sorter.direction === 'asc' ? 1 : -1);
        var _a, _b, _c, _d;
    };
    // #endregion
    // #region View Item Method
    NotificationDialogComponent.prototype.ViewItem = function (item) {
        var result = {
            DualEnrollStudentID: item.DualEnrollStudentID,
            StudentName: item.StudentName,
            StudentID: item.StudentID,
            CollegeID: item.CollegeID,
            Term: item.Term,
            ActionItemID: item.ActionItemID,
            ActionItemName: item.ActionItemName,
        };
        this.dialogRef.close(result);
    };
    return NotificationDialogComponent;
}());
export { NotificationDialogComponent };
// #region Custom Classes
// #region Notification Dialog Options Class
var BaseNotificationDialogOptions = /** @class */ (function () {
    function BaseNotificationDialogOptions() {
    }
    return BaseNotificationDialogOptions;
}());
export { BaseNotificationDialogOptions };
// #endregion
// #endregion



// WEBPACK FOOTER //
// ./src/services/dialogs/notification/notification.dialogcomponent.ts.pre-build-optimizer.js